import React, { useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Typography,
    Chip,
    IconButton,
    Tooltip
} from '@mui/material';
import { Edit, Trash2 } from 'react-feather';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';

const ServiceProviderList = ({ providers, onEdit, onDelete, problemTypes }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [providerToDelete, setProviderToDelete] = useState(null);

    // Get problem type names
    const getProblemTypeNames = (provider) => {
        if (!provider.problem_type_ids || !Array.isArray(provider.problem_type_ids) || provider.problem_type_ids.length === 0) {
            return 'None assigned';
        }

        console.log("PROBLEM TYPES");
        console.log(provider);

        return provider.problem_type_ids.map(id => {
            const problemType = problemTypes.find(pt => pt.id === id);
            return problemType ? problemType.problem_type : '';
        }).filter(Boolean).join(', ');
    };

    // Handle page change
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Open delete confirmation dialog
    const openDeleteConfirm = (provider) => {
        setProviderToDelete(provider);
        setDeleteConfirmOpen(true);
    };

    // Close delete confirmation dialog
    const closeDeleteConfirm = () => {
        setDeleteConfirmOpen(false);
        setProviderToDelete(null);
    };

    // Confirm delete
    const confirmDelete = () => {
        if (providerToDelete) {
            onDelete(providerToDelete.id);
            closeDeleteConfirm();
        }
    };

    // Paginated providers
    const paginatedProviders = providers.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '10px',
                    border: '1px solid rgba(0, 0, 0, 0.08)',
                    overflow: 'hidden',
                    mb: 3
                }}
            >
                <TableContainer>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#F9FAFB' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Specialization</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Contact</TableCell>
                                {/*<TableCell sx={{ fontWeight: 600 }}>Problem Types</TableCell>*/}
                                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 600 }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedProviders.map((provider) => (
                                <TableRow key={provider.id} hover>
                                    <TableCell>
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            {provider.first_name} {provider.last_name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{provider.specialization}</TableCell>
                                    <TableCell>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {provider.phone_number}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                   {/* <TableCell>
                                        <Typography variant="body2" sx={{
                                            maxWidth: 200,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {getProblemTypeNames(provider)}
                                        </Typography>
                                    </TableCell>*/}
                                    <TableCell>
                                        <Chip
                                            label={provider.is_active ? 'Active' : 'Inactive'}
                                            size="small"
                                            sx={{
                                                backgroundColor: provider.is_active ? '#D1FAE5' : '#FEE2E2',
                                                color: provider.is_active ? '#10B981' : '#EF4444',
                                                borderRadius: '4px',
                                                fontSize: '0.75rem',
                                                fontWeight: 500
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onEdit(provider)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    <Edit size={16} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => openDeleteConfirm(provider)}
                                                    color="error"
                                                >
                                                    <Trash2 size={16} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {providers.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                                        <Typography variant="body2" color="textSecondary">
                                            No service providers found
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={providers.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            {/* Delete Confirmation Dialog */}
            <ConfirmDeleteDialog
                open={deleteConfirmOpen}
                onClose={closeDeleteConfirm}
                onConfirm={confirmDelete}
                title="Delete Service Provider"
                message="Are you sure you want to delete this service provider?"
                warningMessage="This action cannot be undone. Any tickets assigned to this provider will be unassigned."
                itemContent={
                    providerToDelete && (
                        <>
                            <Typography variant="subtitle2">
                                {providerToDelete.first_name} {providerToDelete.last_name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {providerToDelete.specialization}
                            </Typography>
                        </>
                    )
                }
            />
        </>
    );
};

export default ServiceProviderList;